import styled from 'styled-components';

interface ItemProps {
  readonly cursor?: string;
  readonly padding?: string;
  readonly bgColor?: string;
}

export const SelectZone = styled.span<ItemProps>`
  cursor: ${props => props.cursor ? props.cursor : 'pointer'};  
`;

export const Column = styled.td<ItemProps>`
  background-color: ${props => props.bgColor ? props.bgColor : 'white'};
`;
